import { render } from "./CriteriaTitleB.vue?vue&type=template&id=d3268f6e&scoped=true"
import script from "./CriteriaTitleB.vue?vue&type=script&lang=js"
export * from "./CriteriaTitleB.vue?vue&type=script&lang=js"

import "./CriteriaTitleB.vue?vue&type=style&index=0&id=d3268f6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3268f6e"]])

export default __exports__